module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3R5fq"))).then(() => module.bundle.root('lKlEc'));